<template>
  <AdminContainer>
    <div class="wrapper">
      <div class="wrapper-header">
        <div class="tabs">
          <button
            class="tab-item"
            :class="{ active: tab_switch == 'user' }"
            @click="switchTab('user')"
          >
            User
          </button>
        </div>
      </div>
      <div class="wrapper-body">
        <affilateUser v-if="tab_switch == 'user'"></affilateUser>
      </div>
    </div>
  </AdminContainer>
</template>
<script>
import AdminContainer from "../views/AdminContainer.vue";
import affilateUser from "../views/Affiliate/affilateUser.vue";
export default {
  components: {
    AdminContainer,
    affilateUser,
  },
  data: () => ({
    tab_switch: "user",
  }),
  watch: {},
  mounted() {},
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
    },
  },
};
</script>
<style lang="scss" >
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;
  .wrapper-header {
    width: 100%;
    height: 70px;
    background: rgb(235, 235, 235);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    .tabs {
      display: flex;
      .tab-item {
        border: none;
        margin-right: 15px;
        text-transform: uppercase;
        background: transparent;
        &.active {
          background: #fff;
          padding: 5px 10px;
          border-radius: 5px;
          color: #8dc73f;
        }
        &:hover {
          color: #8dc73f;
        }
      }
    }
  }
  .wrapper-body {
    height: calc(100% - 70px);
    overflow-y: auto;
  }
}
</style>
